document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-ak-switcher]').forEach((switcher) => {
    const tabs = [...switcher.querySelectorAll('[data-ak-tab]')];
    const groups = [...switcher.querySelectorAll('[data-ak-group]')];
    const prev = switcher.querySelector('[data-ak-prev]');
    const next = switcher.querySelector('[data-ak-next]');
    const dots = switcher.querySelector('[data-ak-dots]');
    const word = switcher.querySelector('[data-ak-switcher-word]');
    const swipeArea = switcher.querySelector('[data-ak-swipe]');

    let activeGroupName = 'beef';
    const indexes = { beef: 0, bacon: 0 };
    let pointerStartX = null;
    let pointerStartY = null;

    const groupFor = (name) => groups.find((group) => group.dataset.akGroup === name);
    const activeSlides = () => [...(groupFor(activeGroupName)?.querySelectorAll('[data-ak-slide]') || [])];

    const buildDots = () => {
      if (!dots) return;
      const slides = activeSlides();
      dots.innerHTML = '';
      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ak-carousel-dot';
        dot.setAttribute('aria-label', `Show product ${index + 1}`);
        dot.addEventListener('click', () => {
          indexes[activeGroupName] = index;
          renderSlides('dot');
        });
        dots.appendChild(dot);
      });
    };

    const renderSlides = (direction = 'next') => {
      const slides = activeSlides();
      if (!slides.length) return;
      const max = slides.length;
      indexes[activeGroupName] = ((indexes[activeGroupName] % max) + max) % max;
      slides.forEach((slide, index) => {
        const active = index === indexes[activeGroupName];
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.dataset.motionDirection = direction;
      });
      [...(dots?.children || [])].forEach((dot, index) => {
        dot.classList.toggle('is-active', index === indexes[activeGroupName]);
        dot.setAttribute('aria-current', index === indexes[activeGroupName] ? 'true' : 'false');
      });
    };

    const setGroup = (name) => {
      if (name === activeGroupName) return;
      activeGroupName = name;
      switcher.dataset.switching = 'true';
      switcher.dataset.activeGroup = name;
      tabs.forEach((tab) => {
        const active = tab.dataset.akTab === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      groups.forEach((group) => {
        const active = group.dataset.akGroup === name;
        group.classList.toggle('is-active', active);
        group.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (word) word.textContent = name === 'bacon' ? 'BACON' : 'BEEF';
      buildDots();
      renderSlides('group');
      window.setTimeout(() => {
        switcher.dataset.switching = 'false';
      }, 420);
    };

    const step = (amount) => {
      const slides = activeSlides();
      if (slides.length < 2) return;
      indexes[activeGroupName] += amount;
      renderSlides(amount > 0 ? 'next' : 'prev');
    };

    tabs.forEach((tab) => tab.addEventListener('click', () => setGroup(tab.dataset.akTab)));
    prev?.addEventListener('click', () => step(-1));
    next?.addEventListener('click', () => step(1));

    swipeArea?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        step(-1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        step(1);
      }
    });

    swipeArea?.addEventListener('pointerdown', (event) => {
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
    });
    swipeArea?.addEventListener('pointerup', (event) => {
      if (pointerStartX === null || pointerStartY === null) return;
      const deltaX = event.clientX - pointerStartX;
      const deltaY = event.clientY - pointerStartY;
      pointerStartX = null;
      pointerStartY = null;

      /* Never treat a vertical/diagonal page scroll as a carousel swipe. */
      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) return;
      step(deltaX < 0 ? 1 : -1);
    });
    swipeArea?.addEventListener('pointercancel', () => {
      pointerStartX = null;
      pointerStartY = null;
    });

    buildDots();
    renderSlides('initial');
  });
});
